/**
 * Shortcode token scanner for CMS-wide embed shortkeys.
 *
 * A body renderer can split a body string into plain-text segments and
 * `{ type: 'embed', key }` segments, then render each embed segment with
 * `<ShortcodeEmbed key={key} />`.
 *
 * Token shape: `{{` + key + `}}`, key matching the registry charset
 * (`[a-z0-9-]`, no leading/trailing hyphen). Anything else is literal text.
 */
export function scanShortcodes(
  text: string,
): Array<string | { type: 'embed'; key: string }> {
  const out: Array<string | { type: 'embed'; key: string }> = []
  let last = 0
  const re = /\{\{([a-z0-9](?:[a-z0-9-]{0,126}[a-z0-9])?)\}\}/g
  let m: RegExpExecArray | null
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) out.push(text.slice(last, m.index))
    out.push({ type: 'embed', key: m[1] })
    last = re.lastIndex
  }
  if (last < text.length) out.push(text.slice(last))
  return out
}
